export default [
    {
        path: 'companies-emisoras',
        component: () => import('@/feature/dashboard/companies-emisores/presentation/views/companies-emisores'),
        meta: {
            title: 'Gestión de entidades emisoras de valores',
            breadcrumb: [
                {label: 'Inicio', link: '/'},
                {label: 'Gestión de entidades emisoras de valores' , link:'/dashboard/companies-emisores'},
            ]
        }
    },
    {
        path: 'companies-emisoras/add',
        component: () => import('@/feature/dashboard/companies-emisores/presentation/views/add'),
        meta: {
            title: 'Gestión de entidades emisoras de valores',
            breadcrumb: [
             {label: 'Inicio', link: '/'},
                {label: 'Gestión de entidades emisoras de valores' , link:'/dashboard/companies'},
                {label: 'Nueva entidad emisora de valores'}
            ]
        }
    },
    {
        path: 'companies-emisoras/edit/:id',
        component: () => import('@/feature/dashboard/companies-emisores/presentation/views/edit'),
        meta: {
            title: 'Gestión de entidades emisoras de valores',
            breadcrumb: [
                {label: 'Inicio', link: '/'},
                {label: 'Gestión de entidades emisoras de valores' , link:'/dashboard/companies'},
                {label: 'Editar entidad emisora de valores'}
            ]
        }
    },
]